import {
  Navigation,
  Pagination,
  Autoplay,
  Grid,
  EffectCoverflow,
  Controller,
  Thumbs,
} from "swiper/modules";
import Swiper from "swiper";

const SwiperCarousel = () => {
  const bannerHomeSwiper = document.querySelector(".bannerHome");
  if (bannerHomeSwiper) {
    new Swiper(bannerHomeSwiper, {
      modules: [Pagination, Autoplay],
      slidesPerView: 1,
      spaceBetween: 0,
      speed: 1250,
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
      autoplay: {
        delay: 8000,
        disableOnInteraction: false,
      },
      loop: true,
    });
  }

  const bannerSegmentos = document.querySelector(".bannerSegmentos");
  if (bannerSegmentos) {
    new Swiper(bannerSegmentos, {
      modules: [Pagination],
      slidesPerView: 1,
      spaceBetween: 0,
      speed: 1250,
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
      autoplay: {
        delay: 8000,
        disableOnInteraction: false,
      },
    });
  }

  const galleryTopEl = document.querySelector(".swiperProdutoPrincipal");
  const galleryThumbsEl = document.querySelector(".swiperThumbs");

  let galleryTopSwiper = null; // variável global da instância swiper principal
  let galleryThumbsSwiper = null; // instância thumbs

  if (galleryThumbsEl && galleryTopEl) {
    // Inicialize thumbs primeiro
    galleryThumbsSwiper = new Swiper(galleryThumbsEl, {
      modules: [Thumbs],
      spaceBetween: 10,
      slidesPerView: 4,
      loop: true,
      freeMode: true,
      loopedSlides: 5,
      watchSlidesVisibility: true,
      watchSlidesProgress: true,
    });

    // Inicialize slider principal e vincule thumbs
    galleryTopSwiper = new Swiper(galleryTopEl, {
      modules: [Navigation, Thumbs],
      spaceBetween: 10,
      loop: true,
      loopedSlides: 5,
      navigation: {
        nextEl: galleryTopEl.querySelector(".swiper-button-next"),
        prevEl: galleryTopEl.querySelector(".swiper-button-prev"),
      },
      thumbs: {
        swiper: galleryThumbsSwiper,
      },
    });
  }

  // ---- Código do zoom e modal ---- //
  if (galleryTopEl && galleryTopSwiper) {
    const zoomIconUrl = galleryTopEl.getAttribute("data-zoom-icon");
    const closeIconUrl = galleryTopEl.getAttribute("data-modal-close-icon");
    const nextIconUrl = galleryTopEl.getAttribute("data-modal-next-icon");
    const prevIconUrl = galleryTopEl.getAttribute("data-modal-prev-icon");

    const zoomIcon = document.createElement("img");
    zoomIcon.src = zoomIconUrl;
    zoomIcon.classList.add("zoom-icon");
    zoomIcon.style.cursor = "pointer";
    galleryTopEl.appendChild(zoomIcon);

    const zoomModalClose = document.querySelector(".zoom-modal-close");
    if (zoomModalClose) {
      zoomModalClose.style.backgroundImage = `url(${closeIconUrl})`;
      zoomModalClose.style.backgroundSize = "contain";
      zoomModalClose.style.backgroundRepeat = "no-repeat";
      zoomModalClose.style.width = "40px";
      zoomModalClose.style.height = "40px";
      zoomModalClose.textContent = "";
    }

    const zoomModalNext = document.querySelector(".zoom-modal-next");
    if (zoomModalNext && nextIconUrl) {
      zoomModalNext.style.backgroundImage = `url(${nextIconUrl})`;
      zoomModalNext.style.backgroundSize = "contain";
      zoomModalNext.style.backgroundRepeat = "no-repeat";
      zoomModalNext.style.width = "44px";
      zoomModalNext.style.height = "44px";
    }

    const zoomModalPrev = document.querySelector(".zoom-modal-prev");
    if (zoomModalPrev && prevIconUrl) {
      zoomModalPrev.style.backgroundImage = `url(${prevIconUrl})`;
      zoomModalPrev.style.backgroundSize = "contain";
      zoomModalPrev.style.backgroundRepeat = "no-repeat";
      zoomModalPrev.style.width = "44px";
      zoomModalPrev.style.height = "44px";
    }

    const zoomModal = document.getElementById("zoomModal");
    const zoomModalSliderWrapper = zoomModal.querySelector(".swiper-wrapper");

    // *** Array global de imagens (atualizado quando troca variação) ***
    window.imagensProduto = [];
    galleryTopEl.querySelectorAll(".swiper-slide img").forEach((img) => {
      window.imagensProduto.push(img.src);
    });

    // Função para montar slides do modal
    function montarSlidesModal() {
      zoomModalSliderWrapper.innerHTML = "";
      window.imagensProduto.forEach((src) => {
        const slide = document.createElement("div");
        slide.classList.add("swiper-slide");
        slide.innerHTML = `<img src="${src}" style="width:100%; height:auto;" />`;
        zoomModalSliderWrapper.appendChild(slide);
      });
    }

    let zoomModalSwiper = null;

    // Dentro da seção do modal, ajuste para pegar o swiper atualizado
    function abrirModal(indiceSlide) {
      montarSlidesModal();
      zoomModal.style.display = "flex";

      if (zoomModalSwiper) {
        zoomModalSwiper.destroy(true, true);
        zoomModalSwiper = null;
      }

      zoomModalSwiper = new Swiper(".zoom-modal-slider", {
        modules: [Navigation],
        navigation: {
          nextEl: ".zoom-modal-next",
          prevEl: ".zoom-modal-prev",
        },
        initialSlide: indiceSlide,
        loop: window.imagensProduto.length > 1,
      });
    }

    zoomIcon.addEventListener("click", () => {
      const swiperAtual = document.querySelector(".swiperProdutoPrincipal");
      if (swiperAtual && swiperAtual.swiper) {
        abrirModal(swiperAtual.swiper.realIndex);
      }
    });

    function fecharModal() {
      zoomModal.style.display = "none";
    }

    zoomIcon.addEventListener("click", () => {
      abrirModal(galleryTopSwiper.realIndex);
    });

    galleryTopEl.querySelectorAll(".swiper-slide img").forEach((img) => {
      img.style.cursor = "zoom-in";
      img.addEventListener("click", (e) => {
        // Pega o slide clicado (não o ativo)
        const slideClicado = e.target.closest(".swiper-slide");
        const todosSlides = Array.from(
          galleryTopEl.querySelectorAll(".swiper-slide")
        );
        const indiceReal = todosSlides.indexOf(slideClicado);

        // Abre modal no índice da imagem clicada
        abrirModal(indiceReal >= 0 ? indiceReal : galleryTopSwiper.realIndex);
      });
    });

    zoomModalClose.addEventListener("click", fecharModal);

    zoomModal.addEventListener("click", (e) => {
      if (e.target === zoomModal) fecharModal();
    });
  }

  const bannerProdutos = document.querySelector(".bannerProdutos");
  if (bannerProdutos) {
    new Swiper(bannerProdutos, {
      modules: [Pagination],
      slidesPerView: 1,
      spaceBetween: 0,
      speed: 1250,
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
      autoplay: {
        delay: 8000,
        disableOnInteraction: false,
      },
    });
  }

  const blogSwiper = document.querySelector(".blogSwiper");
  if (blogSwiper) {
    new Swiper(blogSwiper, {
      modules: [Pagination],
      slidesPerView: 1,
      spaceBetween: 30,
      speed: 1250,
      // centeredSlides: true,
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
      autoplay: {
        delay: 8000,
        disableOnInteraction: false,
      },
    });
  }

  const procuradosSwiper = document.querySelector(".procuradosSwiper");
  if (procuradosSwiper) {
    new Swiper(procuradosSwiper, {
      modules: [Pagination],
      slidesPerView: 1.2, // Mostra um pouco do próximo
      centeredSlides: true,
      spaceBetween: 16,
      speed: 1250,
      initialSlide: 2,
      autoplay: true,
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
      autoplay: {
        delay: 8000,
        disableOnInteraction: false,
      },
    });
  }

  const swiperSolucao = document.querySelector(".solucoesSwiper");
  if (swiperSolucao) {
    new Swiper(swiperSolucao, {
      // modules: [Pagination],
      slidesPerView: 3,
      spaceBetween: 20,
      initialSlide: 2,
      grabCursor: true,
      centeredSlides: true,
      breakpoints: {
        0: {
          slidesPerView: 1,
          spaceBetween: 20,
          initialSlide: 2,
          centeredSlides: true,
        },
        500: {
          slidesPerView: 1.5,
          spaceBetween: 20,
          initialSlide: 2,
          centeredSlides: true,
        },
        992: {
          slidesPerView: 3.5,
          spaceBetween: 20,
          initialSlide: 2,
          centeredSlides: true,
        },
        1500: {
          slidesPerView: 5,
          spaceBetween: 20,
          initialSlide: 2,
          centeredSlides: true,
        },
        1800: {
          slidesPerView: 5,
          spaceBetween: 20,
          initialSlide: 2,
          centeredSlides: true,
        },
      },
    });
  }

  const swiperSegmentosMobile = document.querySelector(".boxPorqueMobile");
  if (swiperSegmentosMobile) {
    new Swiper(swiperSegmentosMobile, {
      // modules: [Pagination],
      slidesPerView: 3,
      spaceBetween: 20,
      initialSlide: 2,
      grabCursor: true,
      centeredSlides: true,
      breakpoints: {
        0: {
          slidesPerView: 2,
          spaceBetween: 20,
          initialSlide: 2,
          centeredSlides: true,
        },
        500: {
          slidesPerView: 1.5,
          spaceBetween: 20,
          initialSlide: 2,
          centeredSlides: true,
        },
        992: {
          slidesPerView: 3.5,
          spaceBetween: 20,
          initialSlide: 2,
          centeredSlides: true,
        },
        1500: {
          slidesPerView: 5,
          spaceBetween: 20,
          initialSlide: 2,
          centeredSlides: true,
        },
        1800: {
          slidesPerView: 5,
          spaceBetween: 20,
          initialSlide: 2,
          centeredSlides: true,
        },
      },
    });
  }

  const swiperFiltragem = document.querySelector(".mySwiperFiltragem");
  if (swiperFiltragem) {
    new Swiper(swiperFiltragem, {
      modules: [EffectCoverflow, Navigation],
      effect: "coverflow",
      grabCursor: true,
      centeredSlides: true,
      loop: false,
      coverflowEffect: {
        rotate: 0,
        stretch: 150, // menor sobreposição entre slides
        depth: 100,
        modifier: 3,
        slideShadows: false,
      },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
    });
  }

  const swiperFiltragem2 = document.querySelector(".mySwiperFiltragem2");
  if (swiperFiltragem2) {
    new Swiper(swiperFiltragem2, {
      modules: [EffectCoverflow, Navigation],
      effect: "coverflow",
      grabCursor: true,
      centeredSlides: true,
      loop: false,
      coverflowEffect: {
        rotate: 0,
        stretch: 155, // menor sobreposição entre slides
        depth: 90,
        modifier: 3,
        slideShadows: false,
      },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
    });
  }

  const swiperDepoimentos = document.querySelector(".swiperSlideTestemunhos");
  if (swiperDepoimentos) {
    new Swiper(swiperDepoimentos, {
      modules: [EffectCoverflow, Navigation],
      // effect: "coverflow",
      // initialSlide: 1,
      // grabCursor: true,
      // centeredSlides: true,
      // slidesPerView: 1.5,
      // spaceBetween: 10,
      // loop: false,
      // coverflowEffect: {
      //   rotate: 0,
      //   stretch: 80,
      //   depth: 110,
      //   modifier: 3,
      //   slideShadows: false,
      // },
      effect: "coverflow",
      initialSlide: 1,
      grabCursor: true,
      centeredSlides: true,
      slidesPerView: 1.5,
      spaceBetween: 10,
      loop: false,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      breakpoints: {
        0: {
          slidesPerView: 1,
          coverflowEffect: {
            rotate: 0,
            stretch: 80,
            depth: 110,
            modifier: 3,
            slideShadows: false,
          },
        },
        992: {
          coverflowEffect: {
            rotate: 0,
            stretch: 80,
            depth: 110,
            modifier: 3,
            slideShadows: false,
          },
        },
      },
    });
  }

  const botoesVariacao = document.querySelectorAll(".btn-tamanho");
  const variacoes = window.variacoesProduto || [];
  const imagemDestacada = window.imagemDestacadaProduto || "";

  botoesVariacao.forEach((btn, index) => {
    btn.addEventListener("click", function () {
      botoesVariacao.forEach((b) => b.classList.remove("active"));
      this.classList.add("active");

      const variacao = variacoes[index];
      const url = new URL(window.location);
      url.searchParams.set("variacao", variacao.slug);
      window.history.pushState({}, "", url);

      document.getElementById("diferencialProduto").innerHTML =
        variacao.descricao;

      if (variacao.imagens && variacao.imagens.length > 0) {
        atualizarSwiper(variacao.imagens);
      }
    });
  });

  // Verifica se tem parâmetro de variação na URL ao carregar a página
  const urlParams = new URLSearchParams(window.location.search);
  const variacaoUrl = urlParams.get("variacao");

  if (variacaoUrl && variacoes.length > 0) {
    // Procura o índice da variação na URL
    const indexVariacao = variacoes.findIndex((v) => v.slug === variacaoUrl);

    if (indexVariacao !== -1) {
      // Remove active de todos os botões
      botoesVariacao.forEach((b) => b.classList.remove("active"));

      // Adiciona active no botão correto
      if (botoesVariacao[indexVariacao]) {
        botoesVariacao[indexVariacao].classList.add("active");
      }

      // Atualiza a descrição
      document.getElementById("diferencialProduto").innerHTML =
        variacoes[indexVariacao].descricao;

      // Atualiza as imagens se tiver
      if (
        variacoes[indexVariacao].imagens &&
        variacoes[indexVariacao].imagens.length > 0
      ) {
        atualizarSwiper(variacoes[indexVariacao].imagens);
      }
    }
  }

  function atualizarSwiper(novasImagens) {
    const swiperPrincipalEl = document.querySelector(".swiperProdutoPrincipal");
    const swiperThumbsEl = document.querySelector(".swiperThumbs");
    const galleryTopEl = document.querySelector(".swiperProdutoPrincipal");

    // Verifica se os elementos e swipers existem
    if (
      !swiperPrincipalEl ||
      !swiperPrincipalEl.swiper ||
      !swiperThumbsEl ||
      !swiperThumbsEl.swiper
    )
      return;

    const swiperPrincipal = swiperPrincipalEl.swiper;
    const swiperThumbs = swiperThumbsEl.swiper;

    // Monta array: imagem destacada + imagens da variação
    const todasImagens = imagemDestacada
      ? [imagemDestacada, ...novasImagens]
      : novasImagens;

    let slidesPrincipais = "";
    let slidesThumbs = "";

    todasImagens.forEach((img) => {
      slidesPrincipais += `
      <div class="swiper-slide">
        <img src="${img}" alt="Produto" width="560" height="560" style="cursor:zoom-in;">
      </div>
    `;

      slidesThumbs += `
      <div class="swiper-slide">
        <img src="${img}" alt="Thumb" width="131" height="131">
      </div>
    `;
    });

    // Destroi os swipers antes de atualizar
    swiperPrincipal.destroy(true, true);
    swiperThumbs.destroy(true, true);

    // Atualiza o HTML
    document.querySelector(
      ".swiperProdutoPrincipal .swiper-wrapper"
    ).innerHTML = slidesPrincipais;
    document.querySelector(".swiperThumbs .swiper-wrapper").innerHTML =
      slidesThumbs;

    // Recria o swiper de thumbs
    const novoThumbsSwiper = new Swiper(".swiperThumbs", {
      modules: [Thumbs],
      spaceBetween: 10,
      slidesPerView: 4,
      loop: true,
      freeMode: true,
      loopedSlides: todasImagens.length,
      watchSlidesVisibility: true,
      watchSlidesProgress: true,
    });

    // Recria o swiper principal
    const novoPrincipalSwiper = new Swiper(".swiperProdutoPrincipal", {
      modules: [Navigation, Thumbs],
      spaceBetween: 10,
      loop: true,
      loopedSlides: todasImagens.length,
      navigation: {
        nextEl: ".swiperProdutoPrincipal .swiper-button-next",
        prevEl: ".swiperProdutoPrincipal .swiper-button-prev",
      },
      thumbs: {
        swiper: novoThumbsSwiper,
      },
    });

    // Atualiza o array de imagens do modal
    window.imagensProduto = todasImagens;

    // Re-adiciona eventos de click nas novas imagens
    galleryTopEl.querySelectorAll(".swiper-slide img").forEach((img) => {
      img.style.cursor = "zoom-in";
      img.addEventListener("click", (e) => {
        // Pega o slide clicado (não o ativo)
        const slideClicado = e.target.closest(".swiper-slide");
        const todosSlides = Array.from(
          galleryTopEl.querySelectorAll(".swiper-slide")
        );
        const indiceReal = todosSlides.indexOf(slideClicado);

        // Abre modal no índice da imagem clicada
        abrirModal(indiceReal >= 0 ? indiceReal : galleryTopSwiper.realIndex);
      });
    });
  }
};
export { SwiperCarousel };
